import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/mdh/Nav";
import { useAuth } from "@/auth/AuthContext";
import { API, BACKEND } from "@/lib/api";


export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const r = await fetch(`${API}/auth/google/session`, {
                    headers: { "X-Session-ID": sessionId },
                    credentials: "include",
                });
                if (!r.ok) throw new Error("exchange failed");
                const data = await r.json();
                // CRITICAL: persist the user into AuthContext — ProtectedRoute reads
                // context (not router state) on every later in-app navigation.
                setUser(data.user);
                window.history.replaceState(null, "", window.location.pathname);
                navigate(data.is_new_user ? "/onboarding" : "/dashboard", {
                    replace: true,
                    state: { user: data.user },
                });
            } catch {
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4">
            <Logo />
            <p className="font-mono text-xs text-slate-500">Signing you in…</p>
        </div>
    );
}
